var _i18nJs = require("i18n-js");

var _i18nJs2 = _interopRequireDefault(_i18nJs);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

_i18nJs2.default.fallbacks = true;

_i18nJs2.default.translations = {
	en: {
		FrontM: "Front M",
		React_Native: "React Native",
		Description:
			"React Native helps us build cross platform native apps in Javascript.",
		WebM_Bot: "WebM",
		WebM_Bot_Desc: "Search the web - chat style!",
		Betty_Bot: "Betty Botter",
		Betty_Bot_Desc: "Play the Betty Botter Game",
		Chat_Input_Camera: "Camera",
		Chat_Input_Video: "Video",
		Chat_Input_Photo_Library: "Photo/Video Library",
		Chat_Input_OCR: "OCR",
		Chat_Input_BarCode: "Barcode Reader",
		Add_Contact: "Add Contact",
		My_Contacts: "My Contacts",
		Favorites: "Favourites",
		Contacts: "Contacts",
		Channels: "Channels",
		ChatBots: "ChatBots",
		Configure: "Configure",
		Authenticate: "Authenticate",
		Bot_Store: "Bot Directory",
		Featured: "Featured",
		Developer: "Company",
		Categories: "Categories",
		Bots: "Bots",
		Filters: "Filters",
		Search: "Search",
		Installed_bots: "Installed Bots",
		Done: "Done",
		Button: "Button",
		Image_Save_Failed: "Saving the image to the Photo Album failed.",
		Image_Save_Success: "Saved the image to the Photos Album",
		Slider_Response_Message: "You selected : \n{{lines}}",
		Slider_Response: "{{lines}}",
		SNR_Chart_title: "Signal to Noise ratio",
		Conversations: "Chats",
		Bot_uninstalled: "Bot uninstalled",
		Bot_uninstall_failed: "Bot uninstall failed",
		Bot_installed: "Bot installed",
		Bot_install_failed: "Bot install failed",
		Bot_uninstall_confirmation: "Are you sure you want to uninstall the bot ?",
		Install: "INSTALL",
		Installed: "INSTALLED",
		Update_Bot: "UPDATE",
		Tap_To_Load: "Tap to Load Image",
		Tap_on_Map: "Long Press on the Map to select a location",
		Tap_on_Map_to_Change:
			"Long Press on another location if you want to change",
		Pick_Location: "Pick Location",
		Name: "Name",
		Email: "Email",
		Screen_Name: "Screen Name",
		UUID: "uuid",
		Given_Name: "Given Name",
		Sur_Name: "Sur Name",
		Chats: "Chats",
		Reset_Conversation: "Reset Conversation",
		Network_Error_Title: "Connection Issues",
		Network_Error_Content:
			"It appears we are having trouble connecting to the internet. Please retry in some time.",
		Retry_Now: "Retry Now",
		Cancel: "Cancel",
		Use: "Use",
		OPEN: "OPEN",
		Web_content_shown: "Web content shown",
		Bot_load_failed_title: "Bot load failed",
		Bot_load_failed:
			"It appears we are having trouble connecting to the internet. Please retry in some time.",
		Take_picture: "Take a picture",
		Select_image: "Select an image",
		Fill_form: "Please fill the form",
		View_form: "View the form details",
		Close: "Close",
		Yes: "Yes",
		Password_not_empty: "Please enter a password",
		Not_a_number: "Please enter a number",
		Field_mandatory: "Field is mandatory",
		Channel_unsubscribed: "Unsubscribed from the channel",
		Channel_unsubscribe_failed: "Failed to unsubscribe from the channel",
		Unknown: "Unknown",
		No_Network: "No network connection",
		Satellite_connection: "Online over Satellite",
	},
};

export default _i18nJs2.default;
